import * as React from "react";

function IconSiren(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_346_8267)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.042 10.04a.584.584 0 00-.575-.483h-.291V4.939l-.002-.125a4.175 4.175 0 00-8.35.126v4.617h-.292a.584.584 0 00-.575.484L.75 11.236h10.5l-.208-1.196zM5.55 3.61a.45.45 0 01.9 0v1.858a.45.45 0 11-.9 0V3.61zM6 6.67a.592.592 0 110 1.183.592.592 0 010-1.184z"
          fill="#FF4242"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_346_8267">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconSiren = React.memo(IconSiren);
export default MemoIconSiren;
